module.exports = __webpack_public_path__ + "img/logo_white.a36c2329.svg";